import React, { useRef } from "react";
import { Button, Form, Modal, notification } from "antd";
import {
	FiArrowLeft,
	FiArrowRight,
	FiCopy,
	FiMessageCircle,
} from "react-icons/fi";
import dayjs from "dayjs";

const ModalPrompt = ({
	historyData,
	openModal,
	onClose = () => {},
	onClickItemPromptLog = () => {},
	onOpenLastMessageModal = () => {},
	onUpdatePrompt = () => {},
	promptData,
}) => {
	const fieldRef = useRef();

	const handleCopyClipboard = () => {
		const text = fieldRef.current.textContent;

		navigator.clipboard
			.writeText(text)
			.then(() => {
				notification.success({ message: "Copied!" });
			})
			.catch((err) => {
				notification.error({
					message: "Failed to copy text to clipboard!",
				});
				console.error("Failed to copy text to clipboard: ", err);
			});
	};

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() =>
				onClose({
					adminPromptShow: false,
					popupShow: true,
				})
			}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() =>
							onClose({
								adminPromptShow: false,
								popupShow: true,
							})
						}
					/>
					Admin Control Prompt
				</div>
				<div
					className="user-profile-wrapper"
					style={{ width: "100%", marginBottom: 24 }}
				>
					<span>Today's prompt context</span>
					<Button
						type="default"
						className="ant-btn-copy"
						icon={<FiCopy />}
						onClick={handleCopyClipboard}
					>
						Copy
					</Button>
				</div>
				<Form>
					<Form.Item>
						<div className="prompt-wrapper" ref={fieldRef}>
							{promptData.thePromptContext}
						</div>
						<small
							style={{
								display: "block",
								width: "100%",
								textAlign: "right",
							}}
						>
							By {promptData.thePromptCreatedBy} @{" "}
							{dayjs(promptData.thePromptCreatedDate).format(
								"HH:mm A - DD MMM, YYYY"
							)}
						</small>
					</Form.Item>
					<Form.Item>
						<Button
							type="primary"
							onClick={() =>
								onUpdatePrompt({
									updatePromptShow: true,
									adminPromptShow: false,
								})
							}
							style={{
								background: "#1E2DD3",
								borderColor: "#1E2DD3",
							}}
						>
							Update prompt context
							<FiArrowRight />
						</Button>
					</Form.Item>
					<Form.Item>
						<Button
							type="primary"
							onClick={() =>
								onOpenLastMessageModal({
									lastMessageShow: true,
									adminPromptShow: false,
								})
							}
						>
							Last Message
							<FiMessageCircle />
						</Button>
					</Form.Item>
				</Form>
				<div className="prompt-history-wrapper">
					<div className="section-title">Prompt Context Log</div>
					<div className="content-wrapper">
						{historyData.map((item, idx) => (
							<Button
								key={idx}
								className="content-item"
								onClick={() =>
									onClickItemPromptLog({
										historyPromptShow: true,
										adminPromptShow: false,
										theHistoryPromptItem: item,
									})
								}
							>
								<span className="left">
									<span className="date">
										{dayjs(item.updatedDate).format(
											"HH:mm A - DD MMM, YYYY"
										)}
									</span>
									<span className="user">
										Updated by {item.updatedBy}
									</span>
								</span>
								<FiArrowRight />
							</Button>
						))}
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ModalPrompt;
